/*
 * Copyright (c) 2015 - 2022 by KAA Soft. All rights reserved.
 */
export var adminConfig = {
  routes: {
    getTemplate: '/admin/get-template',
    imageUpload: '/admin/image/upload'
  },
  dateFormat: {
    time24Format: 'HH:mm:ss',
    time12Format: 'hh:mm a',
    dateTimeFormat: 'MM/DD/YYYY hh:mm a',
    dateTimeDBFormat: 'YYYY-MM-DD HH:mm:ss'
  },
  messages: {
    containerIdNotSpecified: i18n.gettext("Container Id is not specified"),
    containerNotExist: i18n.gettext("Container is not exist"),
    routeNotSpecified: i18n.gettext("Route is not specified"),
    formIdNotSpecified: i18n.gettext("Form Id is not specified"),
    formNotExist: i18n.gettext("Form is not exist"),
    formNotValid: i18n.gettext("Form is not valid"),
    fingerprintNotSpecified: i18n.gettext("Fingerprint is not specified"),
    codeNotSpecified: i18n.gettext("Code is not specified"),
    selectSearchTypeNotSpecified: 'Select Search Type is not specified',
    imageTypeNotSpecified: 'Image Type is not specified',
    noRecords: i18n.gettext('No records found'),
    fieldRequired: i18n.gettext('This field is required')
  },
  handlersFn: [],
  lazyLoad: true,
  forms: [],
  modals: [],
  selects: [],
  bookCopies: [],
  users: [],
  errors: {
    containerId: 'Container Id is not specified',
    container: 'Container Id is not exist',
    route: 'Route is not specified',
    imageType: 'Image Type is not specified.',
    selectSearchType: 'Select Search Type is not specified',
    formId: 'Form Id is not specified',
    form: 'Form Id is not exist',
    formValid: 'Form is not valid'
  }
};

// Object.defineProperty(window, 'ivo_config', {
//     value: ivo_config
// });